module.exports = __webpack_public_path__ + "img/chinesecompany69.c1333a5a.png";